module.exports = __webpack_public_path__ + "cruise.png";